export const getSelectSize = (label: string, select: HTMLSelectElement): string => {
    //create a dummy span with same styles as select just to get its width
    const dummy = document.createElement('span');
    dummy.textContent = label;
    const selectStyles = getComputedStyle(select);
    dummy.style.fontFamily = selectStyles.fontFamily;
    dummy.style.fontStyle = selectStyles.fontStyle;
    dummy.style.fontWeight = selectStyles.fontWeight;
    dummy.style.fontSize = selectStyles.fontSize;

    document.body.appendChild(dummy);

    const width = dummy.offsetWidth + 'px';
    document.body.removeChild(dummy);
    return width;
};
